import { apiV1 } from './api';

const getCompanies = (page = 1, name = '', params) =>
  apiV1.get(`/companies?page=${page}&by_name=${name}`, { params }).then(({ data }) => data);

const getSimilarCompanies = (name, email) =>
  apiV1
    .get('/companies/similar', { params: { name, email } })
    .then(({ data }) => data.companies || []);

const getCompany = companyId => apiV1.get(`/companies/${companyId}`).then(({ data }) => data);

const createCompany = company => {
  const hasFiles = company.civilLiabilityInsuranceFile || company.decennialGuaranteeFile;
  if (!hasFiles) return apiV1.post('/companies', { company }).then(({ data }) => data);

  const formData = new FormData();
  Object.entries(company).forEach(([key, value]) => {
    if (value == null) return;
    const name = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    if (Array.isArray(value)) value.forEach(item => formData.append(`company[${name}][]`, item));
    else formData.append(`company[${name}]`, value);
  });
  return apiV1
    .post('/companies', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(({ data }) => data);
};

const updateCompany = (companyId, company) =>
  apiV1
    .put(`/companies/${companyId}`, {
      company,
    })
    .then(({ data }) => data);

const deleteCompany = companyId => apiV1.delete(`/companies/${companyId}`);

const uploadLegalDocument = (companyId, documentType, file) => {
  const formData = new FormData();
  formData.append('documentType', documentType);
  formData.append('documentFile', file);

  return apiV1
    .post(`/companies/${companyId}/upload_legal_document`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(({ data }) => data);
};

export const companiesAPI = {
  getCompanies,
  getSimilarCompanies,
  getCompany,
  createCompany,
  updateCompany,
  deleteCompany,
  uploadLegalDocument,
};
